import React from 'react';

/**
 * Renders a news story's body text. A paragraph written as
 * `[[image:URL|Alt text]]` is rendered as an inline image at that point
 * in the story, so images can sit between specific paragraphs.
 */
const IMAGE_MARKER = /\[\[image:([^|\]]+)(?:\|([^\]]*))?\]\]/g;
export function StoryBody({
  text,
  className
}: {
  text: string;
  className?: string;
}) {
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  IMAGE_MARKER.lastIndex = 0;
  while ((match = IMAGE_MARKER.exec(text)) !== null) {
    const before = text.slice(lastIndex, match.index).replace(/\s+$/, '');
    if (before) parts.push(<span key={`t-${lastIndex}`} data-id="element-3357" data-mp="1wq0mm8ixk8vk">{before}</span>);
    parts.push(<figure key={`i-${match.index}`} className="not-prose my-8 flex justify-center" data-id="element-3358" data-mp="21olrwmd1hiqv">
        <img src={match[1].trim()} alt={match[2]?.trim() ?? ''} loading="lazy" decoding="async" className="w-full max-w-md h-auto" data-id="element-3359" data-mp="2pe684xht61wg" />
      </figure>);
    lastIndex = match.index + match[0].length;
  }
  const rest = text.slice(lastIndex).replace(/^\s+/, '');
  if (rest) parts.push(<span key={`t-${lastIndex}`} data-id="element-3360" data-mp="fl8lk17jzaij">{rest}</span>);
  return <div className={className} data-id="element-3361" data-mp="tfroqevbmi1w">{parts}</div>;
}

/** Removes inline image markers, for plain-text previews. */
export function stripImageMarkers(text: string): string {
  return text.replace(IMAGE_MARKER, '').replace(/\n{3,}/g, '\n\n');
}